export default [{
  path: '/roles',
  name: 'roles',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/roles/index')
}]
